import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch, post } from "../../../Util/axios_helper";

const year = new Date().getFullYear().toString();
const initialState = {
  cardData: [],
  cardDataLoaded: false,
  barData: [],
  barDataLoaded: false,
};
export const getCountOnLeadCardsData = createAsyncThunk(
  "getCountOnLeadCardsData",
  async (obj) => {
    return await fetch(
      `Analytics/GetCountsOnLead_Card?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
    );
  }
);

export const getCountOnLeadBarData = createAsyncThunk(
  "getCountOnLeadBarData",
  async (obj) => {
    return await fetch(
      `Analytics/GetCountsOnLead_Bar?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
    );
  }
);

export const getCountOnLeadData = createAsyncThunk(
  "getCountOnLeadData",
  async (obj) => {
    return await fetch(
      `Analytics/GetCountsOnLead_Dashboard?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`
    );
  }
);

export const report_countsonLead = createAsyncThunk(
  "report_countsonLead",
  async (obj) => {
    return await fetch(
      `Report/CountsOnLead_Report?type=${obj.type}&years=${obj.years}&filter=${obj.filter}&metrics=${obj.metrics}&value=${obj.value}`,
      {
        responseType: "blob",
      }
    );
  }
);

const CountOnLeadSlice = createSlice({
  name: "countOnLead",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getCountOnLeadCardsData.pending, (state) => {
      state.cardDataLoaded = false;
    });
    builder.addCase(getCountOnLeadCardsData.fulfilled, (state, data) => {
      state.cardData = data.payload;
      state.cardDataLoaded = true;
    });
    builder.addCase(getCountOnLeadCardsData.rejected, (state) => {
      state.cardDataLoaded = true;
      state.barDataLoaded = null;
    });
    builder.addCase(getCountOnLeadBarData.pending, (state) => {
      state.barDataLoaded = false;
    });
    builder.addCase(getCountOnLeadBarData.fulfilled, (state, data) => {
      state.barData = data.payload;
      state.barDataLoaded = true;
    });
    builder.addCase(getCountOnLeadBarData.rejected, (state) => {
      state.barDataLoaded = true;
      state.barData = null;
    });
    builder.addCase(report_countsonLead.pending, (state) => {
      state.barDataLoaded = false;
    });
    builder.addCase(report_countsonLead.fulfilled, (state, data) => {
      state.barData = data.payload;
      state.barDataLoaded = true;
    });
    builder.addCase(report_countsonLead.rejected, (state) => {
      state.barDataLoaded = true;
      state.barData = null;
    });

    builder.addCase(getCountOnLeadData.pending, (state) => {
      state.barDataLoaded = false;
    });
    builder.addCase(getCountOnLeadData.fulfilled, (state, data) => {
      state.barData = data.payload;
      state.barDataLoaded = true;
    });
    builder.addCase(getCountOnLeadData.rejected, (state) => {
      state.barDataLoaded = true;
      state.barData = null;
    });
  },
});

export default CountOnLeadSlice.reducer;
